import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../../../layouts/DashboardLayout";
import api from "../../../api";
import AvatarPreview from "../../../components/AvatarPreview";
import { UserCircle } from "lucide-react";

export default function AvatarEdit() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: "",
        age_group: "",
        avatar_provider: "",
        avatar_id: "",
        updated_by: 1, // Replace with logged-in user id
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadAvatar = async () => {
            try {
                const res = await api.fetchAvatar(id);
                setForm(res.data);
            } catch (err) {
                setError("Failed to load avatar");
            } finally {
                setLoading(false);
            }
        };
        loadAvatar();
    }, [id]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value.replace(".glb", "") });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.updateAvatar(id, form);
            navigate("/avatar");
        } catch (err) {
            setError("Failed to update avatar");
        }
    };

    if (loading) return <DashboardLayout><p>Loading...</p></DashboardLayout>;

    return (
        <DashboardLayout>
            {/* Back Button */}
            <div className="mb-4 max-w-lg mx-auto">
                <button
                    type="button"
                    onClick={() => navigate("/avatar")}
                    className="inline-flex items-center gap-2 text-gray-500 hover:text-gray-800 transition-colors"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                    <span className="font-medium">Back to Avatars</span>
                </button>
            </div>

            <div className="max-w-lg mx-auto bg-white rounded-2xl border border-secondary-100 shadow-sm overflow-hidden">
                <div className="px-6 py-5 border-b border-secondary-100 flex items-center gap-3">
                    <div className="w-9 h-9 bg-primary-100 rounded-xl flex items-center justify-center">
                        <UserCircle className="w-5 h-5 text-primary-600" />
                    </div>
                    <div>
                        <h2 className="text-lg font-bold text-secondary-900">Edit Avatar</h2>
                        <p className="text-xs text-secondary-400">Fields marked <span className="text-red-500">*</span> are required</p>
                    </div>
                </div>
                {error && <p className="text-red-500 px-6 pt-4">{error}</p>}

            <form onSubmit={handleSubmit} className="p-6 space-y-4">
                <div>
                    <label className="block font-medium">Name</label>
                    <input
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        className="w-full border px-3 py-2 rounded"
                        required
                    />
                </div>

                <div>
                    <label className="block font-medium">Age Group</label>
                    <select 
                                name="age_group" 
                                onChange={handleChange}
                                className="border p-2 w-full" 
                                value={form.age_group} required >
                                    <option value="">Select Age Group</option>
                                    <option>Teen</option>
                                    <option>YoungAdult</option>
                                    <option>Adult</option>
                                    <option>MiddleAged</option>
                                    <option>Senior</option>
                            </select>
                </div>

                {/* <div>
                    <label className="block font-medium">Provider</label>
                    <input
                        type="text"
                        name="avatar_provider"
                        value={form.avatar_provider}
                        onChange={handleChange}
                        className="w-full border px-3 py-2 rounded"
                        required
                    />
                </div> */}

                <div>
                    <label className="block font-medium">Avatar ID</label>
                    <input
                        type="text"
                        name="avatar_id"
                        value={form.avatar_id}
                        onChange={handleChange}
                        className="w-full border px-3 py-2 rounded"
                        required
                    />
                    <div className="mt-3">
                        <AvatarPreview
                            avatarUrl={
                                form.avatar_id
                                    ? `https://models.readyplayer.me/${form.avatar_id}.glb`
                                    : null
                            }
                        />
                    </div>
                </div>

                <button
                    type="submit"
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                >
                    Update
                </button>
            </form>
            </div>
        </DashboardLayout>
    );
}
